// @ts-nocheck
/* eslint-disable */
export const llaPlatformArrowRightFullIcon = {
    data: `<svg viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 0.75L15.25 6L9.75 11.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 6H0.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-right-full' as const
};